import { render, staticRenderFns } from "./PurchasingDepartment.vue?vue&type=template&id=fabb6a74&scoped=true"
import script from "./PurchasingDepartment.vue?vue&type=script&lang=js"
export * from "./PurchasingDepartment.vue?vue&type=script&lang=js"
import style0 from "./PurchasingDepartment.vue?vue&type=style&index=0&id=fabb6a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabb6a74",
  null
  
)

export default component.exports